import { Directive, ElementRef, HostListener, Input, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[numeric]'
})
export class NumericDirective {

  @Input('decimals') decimals: any = 0;
  constructor(
          private el: ElementRef, 
          @Optional() private control: NgControl
          ) {}

  private check(value: string) {
    if (this.decimals <= 0) {
      return String(value).match(new RegExp(/^\d+$/));
    } else {
      var regExpString =
        '^\\s*((\\d+(\\.\\d{0,' +
        this.decimals +
        '})?)|((\\d*(\\.\\d{1,' +
        this.decimals +
        '}))))\\s*$';
      return String(value).match(new RegExp(regExpString));
    }
  }

  private run(oldValue: any) {
    setTimeout(() => {
      let currentValue: string = this.el.nativeElement.value;

      if (currentValue === '') {
        if (this.control && this.control.control) {
          // Si está vinculado a un FormControl (tiene formControlName), lo actualiza
          this.control.control.setValue(null);
        } else {
          // Si no está vinculado a un FormControl, actualiza directamente el valor en el DOM
          this.el.nativeElement.value = null;
        }

      } else if (!this.check(currentValue)) {
        if (this.control && this.control.control) {
          // Revertir el FormControl si el valor no es válido
          this.control.control.setValue(oldValue);
        } else {
          // Revertir el valor en el DOM si no es válido
          this.el.nativeElement.value = oldValue;
        }
      }
    });
  }

  @HostListener('blur') onBlur() {
    this.run(this.el.nativeElement.value);
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    this.run(this.el.nativeElement.value);
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    this.run(this.el.nativeElement.value);
  }
  // @Input('decimals') decimals:any = 0;

  //   private check(value: string, decimals: any)
  //   {
  //     if (decimals <= 0) {
  //       return String(value).match(new RegExp(/^\d+$/));
  //     } else {
  //         var regExpString = "^\\s*((\\d+(\\.\\d{0," + decimals + "})?)|((\\d*(\\.\\d{1," + decimals + "}))))\\s*$"
  //         return String(value).match(new RegExp(regExpString));
  //     }
  //   }

  //   private specialKeys = [ 
  //     'Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete'
  //   ];

  //   constructor(private el: ElementRef) {
  //   }

  //   @HostListener('keydown', [ '$event' ])
  //   onKeyDown(event: KeyboardEvent) {
  //       if (this.specialKeys.indexOf(event.key) !== -1) {
  //           return;
  //       }
  //       // Do not use event.keycode this is deprecated.
  //       // See: https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
  //       let current: string = this.el.nativeElement.value;
  //       let next: string = current.concat(event.key);
  //       if ( next && !this.check(next, this.decimals) ) {
  //          event.preventDefault();
  //       }
  //   }

}
